import { Field } from '@lamimed/pantheon';

import { useSubmit } from '../useSubmit';

export function useGetFields({
  Controller,
  errors,
  control,
}: ReturnType<typeof useSubmit>) {
  return {
    company_name: (
      <Controller
        control={control}
        name="company_name"
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render={({ field: { ref, ...fieldProps } }) => (
          <Field
            variant="dark"
            label="Nome dell'azienda*"
            error={errors.company_name?.message}
            {...fieldProps}
          />
        )}
      />
    ),
    name: (
      <Controller
        control={control}
        name="name"
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render={({ field: { ref, ...fieldProps } }) => (
          <Field
            label="Nome*"
            error={errors.name?.message}
            variant="dark"
            {...fieldProps}
          />
        )}
      />
    ),
    surname: (
      <Controller
        control={control}
        name="surname"
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render={({ field: { ref, ...fieldProps } }) => (
          <Field
            label="Cognome*"
            error={errors.surname?.message}
            variant="dark"
            {...fieldProps}
          />
        )}
      />
    ),
    phone: (
      <Controller
        control={control}
        name="phone"
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render={({ field: { ref, ...fieldProps } }) => (
          <Field
            label="Cellulare*"
            type="tel"
            error={errors.phone?.message}
            variant="dark"
            {...fieldProps}
          />
        )}
      />
    ),
    email: (
      <Controller
        control={control}
        name="email"
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render={({ field: { ref, ...fieldProps } }) => (
          <Field
            label="Email*"
            error={errors.email?.message}
            variant="dark"
            {...fieldProps}
            textTransform="lowercase"
          />
        )}
      />
    ),
    message: (
      <Controller
        control={control}
        name="message"
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        render={({ field: { ref, ...fieldProps } }) => (
          <Field
            label="Messaggio"
            error={errors.message?.message}
            variant="dark"
            as="textarea"
            rows={4}
            maxLength={255}
            id="message"
            {...fieldProps}
          />
        )}
      />
    ),
  };
}
